// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1t-M0","box":"WorkspacesBox_box__-DEG6","node":"WorkspacesBox_node__2nAqO"};